export const MessageTranslationsDictionary =
{
    VehicleMessages: "Vehicle Messages",
    DriverMessages: "Driver Messages",
    Dispatch: "Dispatch",
    Recipient: "Recipient",
    FromSystem: "From System",
    MessageLocation: "Please proceed to the designated zone location.",
    Reply: "Reply",
    Read: "Read",
    Delivered: "Delivered",
    Sent: "Sent",
    Pending: "Pending",
    Message: "Message",
    Messages: "Messages",
    SendMessage: "Send message",
    SendAMessage: "Send a message",
    Route: "Route",
    Administrator: "Administrator",
    NoMessages: "No Messages"
};

let getTranslations = () => {
    let r: string[] = [];
    for (const prop in MessageTranslationsDictionary) {
        r.push(MessageTranslationsDictionary[prop]);
    }
    return r;
};

export const MessageTranslations = getTranslations();